import type { GetAccessoryExclusionsResponse } from './accessory-exclusions'

export const getAccessoryExclusionsMock: GetAccessoryExclusionsResponse = {
  title: 'Accessory exclusions',
  image: 'IllustrationDeviceSmartphone',
  paragraphs: [
    {
      icon: 'IconWarning',
      title: 'Less is more',
      text: 'To reduce e-waste, AC adapters and headphones are not included with smartphone orders.',
    },
    {
      icon: 'IconChargingWire',
      title: 'Just the necessities',
      text: 'All phones come with fully compatible, new charging cables. See the "Technical specifications" on item pages for which accessories come with other items.',
    },
    {
      icon: 'IconQuality',
      title: 'New & fully compatible',
      text: 'If an item comes with accessories, they’ll always be new, fully compatible with the item, and subject to the same warranty conditions.',
    },
  ],
}
